import '@egjs/react-flicking/dist/flicking.css';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Select from 'src/shared/components/select/Select';
import { useDashboardCustomerMembershipState } from '../../dahsboardCustomerMembershipState';

interface ExpiryPeriodProps {
  name: string | string[];
  options?: { label: string; value: number | string }[];
  onSelectChange: (value: string, name: string) => void;
}

const ExpiryPeriod = ({ name, options, onSelectChange }: ExpiryPeriodProps) => {
  const {
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  } = useDashboardCustomerMembershipState();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onChange = (date: dayjs.Dayjs) => {
    setDashboardCustomerMembershipState({
      ...dashboardCustomerMembershipState,
      expiryDate: date.toISOString()
    });
    setIsModalOpen(false);
  };

  const { pathname } = useLocation();

  useEffect(() => {
    setDashboardCustomerMembershipState({
      ...dashboardCustomerMembershipState,
      expiryPeriod: ''
    });
  }, [pathname]);

  return (
    <>
      <div className="flex gap-4 items-center">
        <div className="flex flex-col gap-8">
          <div className="flex gap-8 justify-between items-center">
            <Select
              defaultValue="선택"
              options={
                options
                  ? (options as {
                      label: string;
                      value: number | string;
                    }[])
                  : []
              }
              onChange={value => {
                // if (value === 'custom') {
                //   setIsModalOpen(true);
                // }
                onSelectChange(value, typeof name === 'string' ? name : '');
              }}
            />
          </div>
        </div>
        {/* {isModalOpen && (
          <Modal onClose={() => setIsModalOpen(false)}>
            <FibudCalendar onChange={onChange} />
          </Modal>
        )} */}
      </div>
    </>
  );
};

export default ExpiryPeriod;
